// src/store/auth.js
import { defineStore } from 'pinia';
import api from '../services/api';
import { jwtDecode } from 'jwt-decode';
import { useDashboardStore } from './dashboard'; // Impor store dasbor

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('token') || null,
    userRole: null,
  }),
  getters: {
    isAuthenticated: (state) => !!state.token,
  },
  actions: {
    async login(credentials) {
      try {
        const response = await api.login(credentials);
        const token = response.data.access_token;
        this.token = token;
        localStorage.setItem('token', token);
        
        const decoded = jwtDecode(token);
        this.userRole = decoded.role;

        return Promise.resolve();
      } catch (error) {
        this.logout();
        return Promise.reject(error);
      }
    },
    logout() {
      // Panggil aksi clear dari store lain SEBELUM me-reset state lokal
      const dashboardStore = useDashboardStore();
      dashboardStore.clearDashboardState();

      this.token = null;
      this.userRole = null;
      localStorage.removeItem('token');
    },
    loadStateFromStorage() {
      const token = localStorage.getItem('token');
      if (token) {
        this.token = token;
        try {
          const decoded = jwtDecode(token);
          this.userRole = decoded.role;
        } catch (error) {
          console.error("Invalid token found in storage", error);
          this.logout();
        }
      }
    }
  },
});